import { format, formatDistanceToNowStrict, isValid, parseISO } from 'date-fns';

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = parseISO(iso);
  return isValid(d) ? format(d, 'dd MMM yyyy HH:mm:ss') : '—';
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = parseISO(iso);
  return isValid(d) ? format(d, 'dd MMM yyyy') : '—';
}

export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return 'never';
  const d = parseISO(iso);
  return isValid(d) ? `${formatDistanceToNowStrict(d)} ago` : 'never';
}

export function hoursSince(iso: string | null | undefined): number | null {
  if (!iso) return null;
  const d = parseISO(iso);
  if (!isValid(d)) return null;
  return (Date.now() - d.getTime()) / 3_600_000;
}

export const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

/**
 * Ops see a masked number; admins can reveal. Masking happens client-side for display
 * only — the API already returns the full number to authorised callers.
 */
export function displayPhone(phone: string, reveal: boolean): string {
  if (reveal) return phone;
  if (!phone.startsWith('+') || phone.length < 8) return '••••';
  return `${phone.slice(0, 3)} ${phone.slice(3, 8)} ••••${phone.slice(-2)}`;
}
